/** W2 — deterministic resets when Application or physical source changes in Legacy/Successor create. */

export function buildApplicationChangeResetPatch(applicationId: number): {
  applicationId: number;
  loadingPointType: undefined;
  loadingPointId: undefined;
  cargoIds: [];
} {
  return {
    applicationId,
    loadingPointType: undefined,
    loadingPointId: undefined,
    cargoIds: []
  };
}

export function buildPhysicalSourceClearPatch(): {
  loadingPointType: undefined;
  loadingPointId: undefined;
  cargoIds: [];
} {
  return {
    loadingPointType: undefined,
    loadingPointId: undefined,
    cargoIds: []
  };
}
